import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';


const MotionScroll = (props) => {

  const [children, setChildren] = useState(props.children);

  return(
    <motion.div
      variants={{
        offscreen: { // 画面外の場合のスタイル
          y: 10,
          opacity: 0,
        },
        onscreen: { // 画面内の場合のスタイル
          y: 0,
          opacity: 1,
          transition: {
            duration: 0.3,
            ease: "easeInOut",
          },
        },
      }}
      initial="offscreen" // 初期表示はoffscreen
      whileInView="onscreen" // 画面内に入ったらonscreen
      viewport={{ once: true, amount: 0.5 }}
    >
      { children }
    </motion.div>
  )
}

export default MotionScroll;
